import { Thread, Threads } from "@/models/Thread";
import { useAPI } from "../useAPI";
import endpoints from "./threads.endpoint";
import { ThreadsResponse } from "./threads.type";

export const useThreads = () => {
  // 共通APIコール処理を使用
  return useAPI<ThreadsResponse, Threads>(
    endpoints.GET_THREADS,
    responseToModel,
    {
      fallbackData: new Threads(), // 初期値として空のThreadsを設定
    },
  );
};

const responseToModel = (response: ThreadsResponse): Threads => {
  const threadsList = response.threads.map((thread) =>
    new Thread(
      thread.id,
      thread.title,
      new Date(thread.createdAt),
      new Date(thread.updatedAt),
    )
  );
  return new Threads(threadsList);
};
